import React, { useEffect, useState } from "react";
import {
    Spinner,
    Table,
} from "react-bootstrap";
import useReactRouter from "use-react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import * as _ from "lodash";
import { useInitFbSDK } from "../../../helpers/fb-hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Swal from "sweetalert2";
import { useToasts } from "react-toast-notifications";
import AnimationLoading from "../../../components/AnimationLoading";
import "../liveScreen/liveScreen.css";
import { GET_LIVES } from "../../../graphql/live/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { DELETE_LIVE, UPDATE_LIVE } from "../../../graphql/live/mutation";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import { SHOP } from "../../../graphql/shop/queryShop";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import {
    END_LIVE,
    SEND_NOTI_TO_CUSTOMER,
    UNSUBSCRIBE_LIVE,
} from "../../../graphql/liveManage/subscribeLive";
import { connect } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import { CANCELLED, COLOR_APP, COMPLETED, WARNING } from "../../../constants";
import BasicModal from "../../../components/BasicModal";
import SuccessModal from "../../../components/SuccessModal";
import PaginationHelper from "../../../helpers/PaginationHelper";
import Illustration from "../../../image/Illustration.png";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import LoadingSpinner from "../../../components/LoadingSpinner";

function LiveHistory({ fbdata: { assignedPageList } }) {
    const { addToast } = useToasts();
    const { history } = useReactRouter();
    const { height, width } = useWindowDimensions();

    const LIMIT_PAGE = 30;
    const { _limit, _skip, Pagination_helper } = PaginationHelper();

    // const { _limit, _skip, Pagination_helper } = Pagination_helper();

    // App state
    const [fbUserAccessToken, setFbUserAccessToken] = useState();
    const [liveList, setLiveList] = useState([]);
    const [liveTotal, setLiveTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showGuide, setShowGuide] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [currentStatus, setCurrentStatus] = useState("ALL");
    const [currentList, setCurrentList] = useState("LIVE");
    const [showDeleteLiveConfirm, setShowDeleteLiveConfirm] = useState(false);
    const [showDeleteLiveSuccess, setShowDeleteLiveSuccess] = useState(false);

    //ERROR CHECK
    const [selectedLive, setSelectedLive] = useState();
    const [isContinue, setIsContinue] = useState(false);

    //Pagination
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCountNumber, setPageCountNumber] = useState(1);

    const [selectedPage, setSelectedPage] = useState();
    const [selectedPageName, setSelectedPageName] = useState("");
    const [selectedPageId, setSelectedPageId] = useState("");
    const [selectedPageToken, setSelectedPageToken] = useState("");

    const [getLivesData, { data: livesData, loading: liveDataLoading }] = useLazyQuery(GET_LIVES, {
        fetchPolicy: "cache-and-network",
    });
    const [getLiveShopStock, { data: liveShopStockDataForDelete }] = useLazyQuery(
        GET_LIVE_STOCKS,
        { fetchPolicy: "cache-and-network" }
    );
    const [getLiveShopStockForValidate, { data: liveShopStockDataForValidate }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
    const [getShop, { data: shopValidatedData }] = useLazyQuery(SHOP, {
        fetchPolicy: "cache-and-network",
    });
    const [getShopSetting, { data: shopSettingData }] = useLazyQuery(
        GET_SETTINGS,
        { fetchPolicy: "cache-and-network" }
    );

    const [deleteLive] = useMutation(DELETE_LIVE);
    const [updateStock] = useMutation(UPDATE_STOCK);
    const [updateLive] = useMutation(UPDATE_LIVE);
    const [unsubscribeLive] = useMutation(UNSUBSCRIBE_LIVE);
    const [endLiveVDO] = useMutation(END_LIVE);
    const [sendNotiToCustomer] = useMutation(SEND_NOTI_TO_CUSTOMER);

    // useEffect(() => {
    //     onNextOrBackPage();
    // }, [_skip])


    useEffect(() => {
        // getLives();
        // onNextOrBackPage();
        getFacebookLoginStatus();
        window.onpopstate = () => {
            // getLives();
            // onNextOrBackPage();
        };
    }, []);

    useEffect(() => {
        if (livesData?.lives) {
            setIsLoading(false);
            setLiveList(livesData?.lives?.data);
            setLiveTotal(livesData?.lives?.total);
            setPageCountNumber(parseInt(livesData?.lives?.total / LIMIT_PAGE) + 1);
        }
    }, [livesData]);

    // useEffect(() => {
    //     onNextOrBackPage();
    // }, [pageNumber]);

    useEffect(() => {
        getLives();
    }, [_skip])

    const getLives = async () => {
        try {
            setLoading(true);
            let SHOP_ID = await localStorage.getItem("SHOP");
            await getLivesData({
                variables: {
                    where: {
                        shop: SHOP_ID,
                        isDeleted: false,
                        status: [COMPLETED, WARNING, CANCELLED]
                    },
                    limit: _limit,
                    skip: _limit * (_skip - 1),
                    orderBy: "createdAt_DESC",
                },
            });
            // await getShopSetting({
            //     variables: {
            //         where: {
            //             shop: SHOP_ID,
            //         },
            //         orderBy: "createdAt_ASC"
            //     },
            // });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log("Error retrieving posts", error);
        }
    };

    const onNextOrBackPage = async () => {
        try {
            setIsLoading(true);
            let SHOP_ID = await localStorage.getItem("SHOP");

            let _where = {
                shop: SHOP_ID,
                isDeleted: false,
                status: [COMPLETED, WARNING, CANCELLED]
            };

            //check if status is selected
            if (currentStatus != "ALL") {
                _where = {
                    ..._where,
                    status: currentStatus,
                };
            }

            await getLivesData({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                    orderBy: "createdAt_DESC",
                },
            });
        } catch (error) {
            console.log("error: ", error);
        }
    };

    const _selectListLiveWithStatus = async (value) => {
        try {
            // setLoading(true)
            const SHOP_ID = await localStorage.getItem("SHOP");
            if (!value) {
                await getLivesData({
                    variables: {
                        where: {
                            shop: SHOP_ID,
                            isDeleted: false,
                        },
                        orderBy: "createdAt_DESC",
                    },
                });
            } else {
                await getLivesData({
                    variables: {
                        where: {
                            shop: SHOP_ID,
                            description: value ?? "",
                            isDeleted: false,
                        },
                        orderBy: "createdAt_DESC",
                    },
                });
            }
            // setLoading(false)
        } catch (error) {
            setLoading(false);
            console.log("error: ", error);
        }
    };

    const getFacebookLoginStatus = () => {
        try {
            window.FB.getLoginStatus((response) => {
                if (response.authResponse)
                    setFbUserAccessToken(response.authResponse.accessToken);
            });
        } catch (error) {
            console.log("Error FACEBOOK STATUS", error);
        }
    };

    const _goLiveDetail = (live) => {
        history.push(`/live-detail`, { live });
    };

    /***************************
     * Update Stock
     * Restore product amount when delete live
     **************************/
    const _updateShopStock = async () => {
        await getLiveShopStock({
            variables: {
                where: {
                    live: deleteData?.id,
                },
                orderBy: "createdAt_DESC",
            },
        });
    };

    useEffect(() => {
        if (liveShopStockDataForDelete) {
            let _updateStockData = liveShopStockDataForDelete?.liveStocks?.data;
            _updateStockData.map((lStock, index) => {
                _updateStockWhenDelete(lStock);
            });
        }
    }, [liveShopStockDataForDelete]);

    const _updateStockWhenDelete = async (lStock) => {
        await updateStock({
            variables: {
                where: {
                    id: lStock?.stock?.id,
                },
                data: {
                    amount: lStock?.stock?.amount + lStock?.amount,
                    isUsing: false
                },
            },
        });
    };

    const _deleteLive = async () => {
        if (deleteData) {
            try {
                setIsLoading(true);
                if (deleteData.status != "COMPLETED") {
                    /***************************
                     * Update Stock
                     * Restore product amount
                     **************************/
                    await _updateShopStock();
                }
                /***************************
                 * Delete live record
                 **************************/
                await deleteLive({
                    variables: {
                        where: {
                            id: deleteData?.id,
                        },
                    },
                });
                let _liveList = [...liveList];
                _.remove(_liveList, { id: deleteData?.id });
                setLiveList(_liveList);
                setIsLoading(false);
                setShowDeleteModal(false);
                triggerShowDeleteLiveSuccess();

                addToast("ລຶບໄລຟສໍາເລັດ", {
                    appearance: "success",
                    autoDismiss: true,
                });
                setDeleteData();
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        }
    };

    const onNextPage = () => {
        setPageNumber(
            parseInt(pageNumber) != parseInt(pageCountNumber)
                ? parseInt(pageNumber) + 1
                : parseInt(pageCountNumber)
        );

    };

    const onBackPage = () => {
        setPageNumber(parseInt(pageNumber) != 1 ? parseInt(pageNumber) - 1 : 1);
    };

    const onChoosePage = (page) => {
        setPageNumber(parseInt(page));
    };

    const triggerShowDeleteLiveConfirm = () => setShowDeleteLiveConfirm(true);
    const triggerHideDeleteLiveConfirm = () => setShowDeleteLiveConfirm(false);
    const triggerHideDeleteLiveSuccess = () => setShowDeleteLiveSuccess(false);
    const triggerShowDeleteLiveSuccess = () => setShowDeleteLiveSuccess(true);

    const handleDeleteLive = async () => {
        await _deleteLive();
        await triggerHideDeleteLiveConfirm();

        setTimeout(() => {
            triggerHideDeleteLiveSuccess();
        }, 1500);
    };

    // if (liveDataLoading && !livesData?.lives) return <AnimationLoading />

    return (
        <div style={{ padding: 0, margin: 0 }}>
            {/* {loading ? <AnimationLoading /> : <div />}
            {isLoading ? <AnimationLoading /> : <div />} */}

            {(liveDataLoading && !livesData?.lives) ? <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                <LoadingSpinner />
            </div>
                : liveList?.length === 0 ? (
                    <div className="no_data">
                        <img src={"/images/no_data.png"} alt="" />
                        <h1>ບໍ່ມີຂໍ້ມູນ</h1>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Table
                            responsive
                            style={{
                                marginTop: "20px",
                                borderCollapse: "collapse",
                                width: "100% ",
                            }}
                        >
                            <thead >
                                <tr style={{ whiteSpace: 'nowrap' }}>
                                    <th style={{ border: "none" }}>ລຳດັບ</th>
                                    <th style={{ border: "none" }}>ຫົວຂໍ້ໄລຟ</th>
                                    <th style={{ border: "none" }}>ເພຈເຊື່ອມຕໍ່</th>
                                    {/* <th style={{ border: "none" }}>ສະຖານະ</th> */}
                                    <th style={{ border: "none" }}>ວັນເວລາ</th>
                                    <th style={{ border: "none" }}>ຈັດການ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {liveList.map((live, index) => (
                                    <tr id="trActionCell" key={live + index} style={{ verticalAlign: "middle" }}>
                                        <td className="index">
                                            {index + 1 + _limit * (_skip - 1)}
                                        </td>
                                        <td style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap', maxWidth: '200px' }}>{live?.description || "ຍັງບໍ່ກໍານົດ"}</td>
                                        <td style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                                            {live?.pageName}
                                        </td>
                                        {/* <td style={{ width: "183px" }}>
                                        <span
                                            className="status"
                                            style={{
                                                width: "fit-content",
                                                paddingLeft: 8,
                                                paddingRight: 8,
                                                borderRadius: "6px",
                                                border: "1px solid #C4C4C4",
                                                color: "#C4C4C4",
                                            }}
                                        >
                                            {convertLiveStatus(live?.status)}
                                        </span>
                                    </td> */}
                                        <td>{moment(live?.createdAt).format("DD/MM/YYYY  HH:mm")}</td>
                                        <td>
                                            {live?.status === "COMPLETED" || live?.status === "CANCELED" || live?.status === "WARNING" ? (
                                                <div
                                                    // className="row-btn"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <CustomButton
                                                        onClick={() => _goLiveDetail(live)}
                                                        eyeIcon
                                                        textStartLive={"ລາຍລະອຽດ"}
                                                    />

                                                    <button
                                                        onClick={() => {
                                                            setDeleteData(live);
                                                            // setShowDeleteModal(true);
                                                            triggerShowDeleteLiveConfirm();
                                                        }}
                                                        // className="btn-icon hiddenActionCell"
                                                        style={{
                                                            marginLeft: 10,
                                                            background: "#F7F7F7",
                                                            borderRadius: "6px",
                                                            borderColor: "#F7F7F7",
                                                            color: "#D21C1C",
                                                            width: "36px",
                                                            height: "36px",
                                                            border: 'none'
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            ) : ""}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: width > 700 ? "space-between" : 'center',
                                alignItems: 'center'
                            }}
                        >
                            {(liveTotal && width > 700) && <div className="show">ກຳລັງສະແດງ {30 * _skip - 29}-{(30 * _skip) > liveTotal ? liveTotal : 30 * _skip} ຈາກ {liveTotal}</div>}
                            <div>
                                {Pagination_helper(liveTotal, "/live-manage/history", ``)}
                            </div>
                            <div />
                        </div>
                        <div
                            style={{
                                padding: "20px 0px 20px 16px",
                                margin: "8px 24px 32px 23px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            ></div>
                        </div>
                    </div>
                )}
            <BasicModal
                show={showDeleteLiveConfirm}
                onHide={triggerHideDeleteLiveConfirm}
                okay={handleDeleteLive}
                title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່"
                leftButtonName="ຍົກເລີກ"
                rightButtonName="ຕົກລົງ"
                Illustration={Illustration} />
            <SuccessModal
                show={showDeleteLiveSuccess}
                onHide={triggerHideDeleteLiveSuccess}
                title="ລຶບສຳເລັດ"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        fbdata: state.fbdata,
    };
};

export default connect(mapStateToProps)(LiveHistory);
